import { createSlice } from '@reduxjs/toolkit';
import { FieldValue } from 'hexabase-sdk/dist/models/items';
import { t_billing_process, t_psg_details, t_hospital_visit, t_simple_inspection_details, OtherDetail } from 'types';
import {
  getDataCPAPFromHospital,
  getDataPSG,
  getListBills,
  getDataCPAPFromHospitalInMonth,
  getDataSimpleInspectionBill,
  getDataOther,
  getDetailInvoice,
  updateFile,
  getBillProcessDetail,
} from './thunk';

interface InitialState {
  invoices: {
    items: t_billing_process[];
    totalItems: number;
  };
  billProcessDetail?: {
    field_values?: FieldValue[];
  };
  detailPSG?: t_psg_details[];
  detailCPAPFromHosital?: {
    items: t_hospital_visit[];
    totalItems: number;
  };
  detailCPAPFromHositalInMonth?: t_hospital_visit[];
  dataSimple?: t_simple_inspection_details[];
  detailOther?: OtherDetail[];
  detailInvoice?: t_billing_process;
  currentPage: number;
  searchValue: {
    facility_code: string;
    facility_name: string;
    year: string;
    month: string;
  };
  updateFileId?: {
    file_id: string;
  };
}

const initialState: InitialState = {
  invoices: {
    items: [],
    totalItems: 0,
  },
  searchValue: { facility_code: '', facility_name: '', year: '', month: '' },
  currentPage: 1,
  updateFileId: {
    file_id: '',
  },
};

const billingSlice = createSlice({
  name: 'billingList',
  initialState,
  reducers: {
    resetDataTab(state) {
      return {
        ...state,
        detailPSG: undefined,
        detailCPAPFromHosital: undefined,
        detailCPAPFromHositalInMonth: undefined,
        dataSimple: undefined,
        detailOther: undefined,
        detailInvoice: undefined,
      };
    },
    resetDetailInvoice(state) {
      return { ...state, detailInvoice: undefined };
    },
    setSearchValueListBilling(state, action) {
      state.searchValue = action.payload;
    },
    setCurrentPageListBilling(state, action) {
      state.currentPage = action.payload;
    },
    resetSearchValueListBilling(state) {
      state.searchValue = { facility_code: '', facility_name: '', year: '', month: '' };
      state.currentPage = 1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getListBills.fulfilled, (state, action) => ({ ...state, invoices: action.payload.data }));
    builder.addCase(getDataPSG.fulfilled, (state, action) => {
      return { ...state, detailPSG: action.payload };
    });
    builder.addCase(getDataCPAPFromHospital.fulfilled, (state, action) => ({
      ...state,
      detailCPAPFromHosital: action.payload,
    }));
    builder.addCase(getDataCPAPFromHospitalInMonth.fulfilled, (state, action) => ({
      ...state,
      detailCPAPFromHositalInMonth: action.payload,
    }));
    builder.addCase(getDataSimpleInspectionBill.fulfilled, (state, action) => {
      return { ...state, dataSimple: action.payload };
    });
    builder.addCase(getDataOther.fulfilled, (state, action) => ({ ...state, detailOther: action.payload }));
    builder.addCase(getDetailInvoice.fulfilled, (state, action) => ({ ...state, detailInvoice: action.payload }));
    builder.addCase(updateFile.fulfilled, (state, action) => ({ ...state, updateFileId: action.payload }));
    builder.addCase(getBillProcessDetail.fulfilled, (state, action) => ({
      ...state,
      billProcessDetail: action.payload,
    }));
  },
});

export const {
  resetDataTab,
  resetDetailInvoice,
  setSearchValueListBilling,
  setCurrentPageListBilling,
  resetSearchValueListBilling,
} = billingSlice.actions;

export default billingSlice.reducer;
